import React, { useEffect, useCallback } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import Login from "./containers/Auth"
import { isLoggedIn, getObject, isTokenExpired, removeAuthObjects, toastError } from './utils';
import MainContainer from "./containers/Main"
import Dashboard from './containers/Dashboard';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn() ? (
        <MainContainer {...props}>
          <Component {...props} />
        </MainContainer>
      )
        : (
          <Redirect to='/login' />
        )
    }
  />
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => isLoggedIn() ? <Redirect to="/" /> : <Component {...props} />
    }
  />
);

function TokenExpiryWatcher() {
  const checkExpiry = useCallback(() => {
    const token = getObject("auth");
    if (token && isTokenExpired(token)) {
      removeAuthObjects();
      toastError("Session expired. Please login again.");
      window.open('/login', '_self');
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(checkExpiry, 60000); // check every minute
    return () => clearInterval(interval);
  }, [checkExpiry]);

  return null;
}

export default function App() {
  return (
    <Router>
      <TokenExpiryWatcher />
      <Switch>
        <PrivateRoute exact path="/" component={Dashboard} />
        <PublicRoute exact path='/login' component={Login} />
        <Redirect to="/login" />
      </Switch>
    </Router>
  );
}
